/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Revenue from './component/revenue'
import './style.css'

class ClubRevenueNew extends React.Component {
  render() {
    return (
      <Revenue
        revenueList={this.props.revenueList}
        statisticType={this.props.statisticType}
        fetchClubRevenue={this.props.fetchClubRevenue}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    revenueList: state.getClubRevenueNew.revenueList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubRevenueNew))



// WEBPACK FOOTER //
// ./src/containers/ClubRevenueNew/index.js